/*
 * @Author: cc
 * @Date: 2020-03-31 16:16:48
 * @LastEditTime: 2021-10-12 13:48:56
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\manageConfig\roleManageMent\roleManageRouter.js
 * @Description: 
 */
/*
    Create By Baizhiming 2015-10-14
*/
'use strict';
angular.module('manageCfg.roleManageMent', ['roleManageMentIframeModule'])
    .config(['$stateProvider', function($stateProvider) {
        $stateProvider.state('manageconfig.rolemanage.permissionassignment', {
            url: '/permissionassignment',
            views: {
                'rightEdit@manageconfig.rolemanage': {
                    templateUrl: './manageConfig/roleManageMent/permissionAssignment/permissionAssignment_tpl.html',
                    controller: 'permissionAssignmentCtrl'
                },
                'footer': {
                    templateUrl: './footer_tpl.html'
                }
            }
        }).state('manageconfig.rolemanage.editorcreaterole', {
            url: '/createrole?type',
            views: {
                'rightEdit@manageconfig.rolemanage': {
                    templateUrl: './manageConfig/roleManageMent/editOrCreateRole/editOrCreateRole_tpl.html',
                    controller: 'createRoleCtrl'
                },
                'footer': {
                    templateUrl: './footer_tpl.html'
                }
            }
        }).state('manageconfig.rolemanage.adduser', {
            url: '/adduser?roleId',
            views: {
                'rightEdit@manageconfig.rolemanage': {
                    templateUrl: './manageConfig/roleManageMent/addUser/addUser_tpl.html',
                    controller: 'userManageMentaddUserController'
                },
                'footer': {
                    templateUrl: './footer_tpl.html'
                }
            }
        }).state('manageconfig.rolemanage.modulevisibility', {
            url: '/modulevisibility',
            views: {
                'rightEdit@manageconfig.rolemanage': {
                    templateUrl: './manageConfig/roleManageMent/moduleVisibility/moduleVisibility_tpl.html',
                    controller: 'moduleVisibilityCtrl'
                },
                'footer': {
                    templateUrl: './footer_tpl.html'
                }
            }
        });
    }]);
